import { render, staticRenderFns } from "./shopBannerMobile.vue?vue&type=template&id=372b217b&scoped=true"
import script from "./shopBannerMobile.vue?vue&type=script&lang=js"
export * from "./shopBannerMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b217b",
  null
  
)

export default component.exports